// Comisiones de las OTAs (7-oct-2026): la tarjeta del anuncio con el % que se queda cada
// canal, el IVA de esa comisión y si la ficha de la reserva enseña lo que de verdad llega.
// Panel: components/Gestores/OtaCommissionsPanel.vue
export const otaCommissions = {
  head: {
    title: "OTA-Provisionen",
    sub: "Was jeder Kanal von Ihren Buchungen einbehält. Damit zeigen Ihnen die Details jeder Buchung eine Schätzung dessen, was bei Ihnen ankommt.",
  },
  loading: "Provisionen werden geladen…",
  loadError: {
    title: "Die Provisionen konnten nicht geladen werden",
    text: "Prüfen Sie die Verbindung und versuchen Sie es erneut.",
    retry: "Erneut versuchen",
  },
  display: {
    title: "Preis der OTA-Buchungen in den Buchungsdetails",
    totalLabel: "Nur der Gesamtbetrag der OTA",
    totalDesc: "Wie bisher: der Betrag der Buchung.",
    netLabel: "Auch, was bei Ihnen ankommt",
    netDesc: "Zusätzlich zum Gesamtbetrag zeigen die Details die Provision, die MwSt. auf die Provision und den Nettobetrag, den Sie erhalten.",
  },
  rates: {
    title: "Provision und Gebühren je OTA",
    hint: "Tragen Sie den Prozentsatz ein, den Sie im Extranet der jeweiligen OTA sehen (bei Booking: „Provision und Gebühren“ ÷ „Gesamtpreis“). Meldet der Kanal die tatsächliche Provision einer Buchung, wird diese verwendet.",
    usual: "üblich: {pct} %",
    airbnbNote: "Airbnb zahlt Ihnen den Betrag bereits netto aus: Die Provision ist schon abgezogen. Lassen Sie das Feld leer (0 %), es sei denn, Ihre Verbindung erhält den Gesamtbetrag.",
    managedNote: "Diese Prozentsätze werden auch in der Abrechnung mit Ihrem Eigentümer verwendet.",
  },
  vat: {
    title: "MwSt. auf die OTA-Provision",
    hint: "Booking berechnet Unterkünften in Spanien MwSt. auf seine Provision (21 %) und zieht sie von der Auszahlung ab. Tragen Sie 0 ein, wenn sie Ihnen nicht berechnet wird.",
  },
  errPercent: "Muss ein Prozentsatz zwischen 0 und 100 sein.",
  example: {
    title: "Beispiel",
    sub: "Eine {channel}-Buchung über {total}",
    total: "Gesamtpreis",
    commission: "Provision und Gebühren von {channel} ({pct} %)",
    vat: "MwSt. auf die Provision ({pct} %)",
    net: "Sie erhalten",
    foot: "Das ist eine Schätzung mit diesen Prozentsätzen: Die OTA kann einen etwas anderen Betrag überweisen (Rundungen, Aktionen, Zahlungsgebühren). Meldet der Kanal die tatsächliche Provision, verwenden die Details diese.",
  },
  footer: {
    save: "Speichern",
    saving: "Wird gespeichert…",
    saved: "Provisionen gespeichert",
    unsaved: "Ungespeicherte Änderungen",
    fixErrors: "Prüfen Sie die markierten Felder",
    errSave: "Die Änderungen konnten nicht gespeichert werden. Bitte versuchen Sie es erneut.",
    errInvalid: "Die Provision jeder OTA muss ein Prozentsatz zwischen 0 und 100 sein.",
  },
};
